import { Button, Grid, TextField } from "@mui/material";
import { useContext } from "react";
import { toolTypologiesContext } from '../ToolTypologiesContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { FilterContainer } from "components";

let Filter = () => {

    let service = useContext(toolTypologiesContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <TextField
                    label="Cerca tipologie"
                    id="search text"
                    size="small"
                    variant="standard"
                    value={service.search.searchText}
                    onChange={(e: any) => service.handleChange({...service.search, searchText: e.target.value})}
                />
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                    aria-label="cerca"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;